<template>
  <v-container fluid grid-list-md>
    <v-layout row wrap>
      <v-flex xs12 lg12>
        <v-card>
          <v-alert color="warning" :value="showWarning">
            Pensez à vérifier votre encours avant la fin du mois
          </v-alert>
          <v-card-title primary-title class="align-baseline d-block">
            <div class="headline">En cours</div>
            <BillDataTable
              :billing-entry="{
                projects: nonZeroOutstanding,
                custom: rewards.custom
              }"
            />
          </v-card-title>
        </v-card>
      </v-flex>
      <v-flex xs12 lg12>
        <BillingHistory />
      </v-flex>
    </v-layout>
  </v-container>
</template>

<script>
import moment from "moment";
import { mapActions, mapState } from "vuex";
import BillDataTable from "../components/billing/BillDataTable";
import BillingHistory from "../components/billing/BillingHistory";

export default {
  components: { BillDataTable, BillingHistory },
  data: function() {
    return {
      showWarning: moment().date() >= 20 // Only show the warning after the 20th
    };
  },
  beforeMount() {
    this.reload();
  },
  computed: {
    ...mapState("user", ["billing", "rewards"]),
    nonZeroOutstanding() {
      return this.billing.outstanding.filter(project => project.amount > 0);
    }
  },
  methods: {
    ...mapActions("user", ["outstandingBilling"]),
    async reload() {
      await this.outstandingBilling();
    }
  }
};
</script>
